import { Space, Table, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { dataGet } from 'src/utils';

export default function SimInfoTable({ dataSim }: any) {
  const columns: ColumnsType<any> = [
    {
      title: 'Gói đang sử dụng',
      dataIndex: 'package_name',
      key: 'package_name',
      render: (_, record) =>
        !!record && (
          <Space size={'small'} wrap>
            {
              <Typography.Text key={0}>
                {record.type === 'DataTransfer'
                  ? 'Gói nạp data'
                  : dataGet(record, 'package_name', '')}
              </Typography.Text>
            }
          </Space>
        ),
    },
    {
      title: 'Ngày kích hoạt',
      dataIndex: 'start_time',
      key: 'start_time',
      render: (_, record) =>
        !!record && (
          <Typography.Text>
            {dataGet(record, 'start_time') ? dataGet(record, 'start_time') : ''}
          </Typography.Text>
        ),
    },
    {
      title: 'Ngày hết hạn',
      dataIndex: 'end_time',
      key: 'end_time',
      render: (_, record) =>
        !!record && (
          <Typography.Text>
            {dataGet(record, 'end_time') ? dataGet(record, 'end_time') : ''}
          </Typography.Text>
        ),
    },
    {
      title: 'Data sử dụng(Mbs)',
      dataIndex: 'total_traffic',
      key: 'total_traffic',
      render: (_, record) =>
        !!record && (
          <Typography.Text>
            {record.type === 'DataTransfer'
              ? ''
              : dataGet(record, 'total_traffic', 0) - dataGet(record, 'available_traffic', 0)}
          </Typography.Text>
        ),
    },
    {
      title: 'Data còn lại(Mbs)',
      dataIndex: 'available_traffic',
      key: 'available_traffic',
      render: (_, record) =>
        !!record && <Typography.Text>{dataGet(record, 'available_traffic') ?? 0}</Typography.Text>,
    },
    {
      title: 'Ngày hết hạn kích hoạt',
      dataIndex: 'expired_date_wait',
      key: 'expired_date_wait',
      render: (_, record) =>
        !!record && (
          <Typography.Text>
            {dataGet(record, 'expired_date_wait') ? dataGet(record, 'expired_date_wait') : ''}
          </Typography.Text>
        ),
    },
  ];

  return (
    <>
      <Table
        size={'small'}
        className='w-full'
        columns={columns}
        scroll={{ x: 750 }}
        dataSource={
          dataSim.packageInfos.length || dataSim.packageTransferInfos.length
            ? [
                ...dataSim.packageInfos,
                ...dataSim.packageTransferInfos.map((item: any) => ({
                  ...item,
                  type: 'DataTransfer',
                })),
              ]
            : []
        }
        pagination={false}
        rowKey={(record) => {
          return record?.simType;
        }}
      />
    </>
  );
}
